import { StepCircleActive } from "@/public/icons/StepCircleActive";
import { StepCircleCompleted } from "@/public/icons/StepCircleCompleted";
import { StepCircleInactive } from "@/public/icons/StepCircleInactive";
import { FC } from "react";
import { DesktopStepIconProps } from "../lib/type";

export const DesktopStepIconRenderer: FC<
  Pick<DesktopStepIconProps, "completed" | "active" | "percent">
> = ({ completed, active, percent }) => {
  if (completed) {
    return <StepCircleCompleted />;
  }
  if (active) {
    return (
      <StepCircleActive
        percent={percent}
        stroke={percent ? "var(--white)" : "transparent"}
      />
    );
  }
  return <StepCircleInactive stroke="var(--bulish-gray)" />;
};
